 document.addEventListener('DOMContentLoaded', function () {
      // Select the target element and the element to add/remove class
      const addToCartButton = document.querySelector('.ProductForm__AddToCart ');
      const stickyContainer = document.querySelector('.sticky_add_to_cart_container');
    
      // Options for the Intersection Observer
      const observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: 0.5, // Trigger when 50% of the target is visible
      };
    
      // Callback function to handle intersection changes
      const handleIntersection = (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Target element is in the viewport
            stickyContainer.classList.remove('sticky_handle');
          } else {
             if (entry.boundingClientRect.top < 0) {
        stickyContainer.classList.add('sticky_handle');
      } else {
        stickyContainer.classList.remove('sticky_handle');
      }
          }
        });
      };
    
      // Create an Intersection Observer instance with the callback function and options
      const intersectionObserver = new IntersectionObserver(handleIntersection, observerOptions);
    
      // Start observing the target element
      intersectionObserver.observe(addToCartButton);
    
      let mainAtc = document.querySelector('.ProductForm__AddToCart');
      let stickyAtc = document.querySelector('.sticky_add_to_btn');
      let stickyAtcText = stickyAtc.innerHTML;
    
      stickyAtc.addEventListener('click', function () {
        mainAtc.click();
        stickyAtc.innerHTML = 'añadiendo..';
    
        setTimeout(function () {
          stickyAtc.innerHTML = stickyAtcText;
        }, 1000);
      });
    
      // Select the target elements
      const productItems = document.querySelectorAll('.ProductForm__Item');
      const stickyCartPrice = document.querySelector('.sticky_price');
    
      // Callback function to handle mutations
      const handleMutation = (mutationsList, observer) => {
        mutationsList.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'aria-expanded') {
            // Call your function when the 'aria-expanded' attribute changes
            changeStickyPrice();
          }
        });
      };
    
      // Create a Mutation Observer instance with the callback function
      const mutationObserver = new MutationObserver(handleMutation);
    
      // Start observing each product item for changes in 'aria-expanded'
      productItems.forEach((productItem) => {
        mutationObserver.observe(productItem, { attributes: true });
      });
    
      // Your function to be called when 'aria-expanded' changes
      function changeStickyPrice() {
        const productPrice = document.querySelector('.ProductMeta__Price ').innerHTML;
        stickyCartPrice.innerHTML = productPrice;
      }
    });